import { render, staticRenderFns } from "./binding4.vue?vue&type=template&id=6cd0efef&scoped=true&"
import script from "./binding4.vue?vue&type=script&lang=js&"
export * from "./binding4.vue?vue&type=script&lang=js&"
import style0 from "./binding4.vue?vue&type=style&index=0&id=6cd0efef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd0efef",
  null
  
)

export default component.exports